import florida from '../assets/jurisdiction/florida.svg';
import indiana from '../assets/jurisdiction/indiana.svg';
import kentucky from '../assets/jurisdiction/kentucky.svg';
import northCarolina from '../assets/jurisdiction/north-carolina.svg';
import ohio from '../assets/jurisdiction/ohio.svg';
import southCarolina from '../assets/jurisdiction/south-carolina.svg';

import floridaReversed from '../assets/jurisdiction/florida-reversed.svg';
import indianaReversed from '../assets/jurisdiction/indiana-reversed.svg';
import kentuckyReversed from '../assets/jurisdiction/kentucky-reversed.svg';
import northCarolinaReversed from '../assets/jurisdiction/north-carolina-reversed.svg';
import ohioReversed from '../assets/jurisdiction/ohio-reversed.svg';
import southCarolinaReversed from '../assets/jurisdiction/south-carolina-reversed.svg';

import ncDec from '../assets/jurisdiction/nc-dec.svg';
import ncDep from '../assets/jurisdiction/nc-dep.svg';
import scDec from '../assets/jurisdiction/sc-dec.svg';
import scDep from '../assets/jurisdiction/sc-dep.svg';

import arrow from '../assets/arrow.svg';
import caret from '../assets/caret.svg';
import empty from '../assets/default.png';
import fan from '../assets/fan.svg';
import heaterTank from '../assets/heater-tank.svg';

const Images = {
  jurisdiction: {
    florida,
    indiana,
    kentucky,
    ohio,
    northCarolina,
    southCarolina,
    ncDec,
    ncDep,
    scDec,
    scDep,
    floridaReversed,
    indianaReversed,
    ohioReversed,
    kentuckyReversed,
    northCarolinaReversed,
    southCarolinaReversed,
  },
  fan,
  empty,
  heaterTank,
  arrow,
  caret,
};

export default Images;
